<div class="row mb-2" *ngIf="component.element.bind_to_variable !== 'email'">
  <label class="mb-1 col-sm-4" translate>Input type</label>
  <div class="col-sm-8">
    <select name="input_type" class="form-select form-select-sm" [(ngModel)]="component.type"
      (ngModelChange)="onInputTypeChange($event)">
      <option [value]="inputType.value" [selected]="inputType.value === component.type"
        *ngFor="let inputType of inputTypes">{{ inputType.label }}</option>
    </select>
  </div>
</div>
<div class="mb-2 form-check">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.show_label" id="show_label" />
  <label for="show_label" class="form-check-label" translate>Show label</label>
</div>
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Input label</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.label" (ngModelChange)="onLabelChange($event)" />
  </div>
</div>
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Placeholder text</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.placeholder_text" />
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Field name</label>
  <div class="col-sm-12">
    <input type="text" name="field_name" [(ngModel)]="component.element.field_name" 
    class="form-control form-control-sm"
      maxlength="100"
      ngModelOptions="{ updateOn: 'blur' }"
      (blur)="sanitizeFieldName()"
      (keydown)="preventSpecialChar($event)"
      (input)="filterSpecialCharOnInput()"
    >
    <small class="text-muted" translate>Max 100 characters and No Special Characters Allowed</small>
  </div>
</div>

<div class="form-check">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.is_required" id="is_required" />
  <label for="is_required" class="form-check-label" translate>Set as required</label>
  <div *ngIf="component.element.is_required && (
      component.element.label?.trim()==='' ||
      component.element.placeholder_text?.trim()==='' ||
      component.element.field_name?.trim()===''
    )" class="text-danger small" translate>
    Value cannot be only spaces.
  </div>
</div>

<div class="form-check mt-2">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.is_trigger_ncr" id="is_trigger_ncr" />
  <label for="is_trigger_ncr" class="form-check-label" translate>Is Trigger NCR?</label>
</div>

<div *ngIf="component.element.is_trigger_ncr" class="mt-2">
  <div class="row mb-2">
    <label class="col-sm-12 mb-1" translate>Min Range</label>
    <div class="col-sm-12">
      <input type="number" class="form-control form-control-sm"  min="0" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);" [(ngModel)]="component.element.min_range" placeholder="Minimum value" />
    </div>
  </div>
  <div class="row mb-2">
    <label class="col-sm-12 mb-1" translate>Max Range</label>
    <div class="col-sm-12">
      <input type="number" class="form-control form-control-sm"  min="0" max="99999" oninput="if(this.value.length > 5) this.value = this.value.slice(0, 5);" [(ngModel)]="component.element.max_range" placeholder="Maximum value" />
    </div>
  </div>
</div>